import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { KeycloakAuthService } from './keycloak-auth.service';

export const AuthGuard: CanActivateFn = () => {
  const authService = inject(KeycloakAuthService);
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);
  if (!isPlatformBrowser(platformId)) {
    return true;
  }
  console.log( authService.getAccessToken());
  if (authService.isLoggedIn()) {
    return true;
  }
  const token = authService.getAccessToken();
  if (token) {
    authService.fetchUser();
    return true;
  } else {
    router.navigate(['/login']);
    return false;
  }

};
